<template>
  <div class="mentIndex">
    <div class="home_con">
       <div class="moment"><Menthu /></div>
      <div class="mentCon">
        <div class="ment_title">数据传输与安全</div>
        <p>1.范围</p>
        <span
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本部分确立了电动汽车充换电服务信息交换的数据传输和安全防护的一般原则，包含充换电服务信息交换的数据传输体系、平台认证要求、密钥的管理和使用要求。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本部分适用于不同运营商服务平台之间的充换电服务信息交换，以及电动汽车充换电服务平台与第三方服务及管理平台之间的信息交换。</span
        >
        <p>2.规范性引用文件</p>
        <span
          >下列文件对于本文件的应用是必不可少的。凡是注日期的引用文件，仅注日期的版本适用于本文件。凡是不注日期的引用文件，其最新版本（包括所有的修改单）适用于本文件。<br />GB/T
          2260-2007 中华人民共和国行政区域代码<br />GB/T 7408-2005
          数据元和交换格式信息交换日期和时间表示法<br />GB/T 9387.1-1998
          信息技术 开放系统互联 基本参考模型 第1部分：基本模型<br />GB/Z
          19027-2005 统计技术指南<br />GB/T 19596-2004 电动汽车术语<br />GB/T
          18391.1-2002 信息技术 数据元的规范与标准化
          第1部分：数据元的规范与标准化框架<br />GB/T 25070-2010
          信息安全技术信息系统等级保护安全设计技术要求 <br />GB/T 20271-2006
          信息安全技术信息系统安全通用技术要求 <br />GB/T 20988-2007
          信息安全技术信息系统灾难恢复规范<br />GB/T 22239-2008
          信息安全技术信息系统安全等级保护基本要求 <br />GB/T 29317-2012
          电动汽车充换电设施术语</span
        >
        <p>3.术语和定义</p>
        <span
          >  GB/T 19596、GB/T 29317、GB/Z
          19027-2005以及《电动汽车充换电服务信息交换
          第1部分：总则》中定义的术语和定义适用于本文件。</span
        >
        <p>4.数据传输体系</p>
        <small>4.1　数据传输一般流程</small>
        <span
          >电动汽车充换电服务信息交换一般需要经过平台认证、请求和应答3个步骤。</span
        >
        <small> 4.2　数据传输接口</small>
        <span
          >所有数据传输接口均采用HTTP(S)接口，每个接口的URL均采用如下格式定义：<br /><br />http(s)://[域名]/evcs/v[版本号]/[接口名称]<br /><br />1)域名：各接入运营商所属域名。<br /><br />2)版本号：代表接口版本号，不同的版本地址对应相应版本代码。系统升级期间，新旧版本可同时存在，待所有接入方都切换到新接口，旧接口即可下线。从而达到平滑升级的目的。<br /><br />3)接口名称：所请求/调用接口的名称，具体接口名称见《电动汽车充换电服务信息交换
          第2部分：公共信息交换规范》和《电动汽车充换电服务信息交换
          第3部分：业务信息交换规范》。<br /><br />为保证各接口的功能明确清晰，每个URL只允许对应一种功能。</span
        >
        <small>4.3　接口调用方式</small>
        <span>
          所有接口均使用HTTP(S)/POST方式传输参数，采用JSON的方式，传输过程中应包含消息头和消息主体两部分。</span
        >

        <small> 4.4　消息头规范</small>
        <span>
          消息头一般需包含内容类型和授权信息（Authorization）。<br /><br />内容类型（Content-Type）字段用于标识请求中的消息主体的编码方式，本标准中所规范的信息交换内容均采用JSON的方式，参数信息采用utf-8编码，因此需要配置消息头中的Content-Type
          为application/json;charset=utf-8。<br /><br />授权信息（Authorization）字段用于证明客户端有权查看某个资源，本标准中所规范的授权信息采用令牌（Token）的方式，因此需要在配置消息头中的Authorization
          为Bearer Token。</span
        >

        <small>4.5　消息主体规范</small>
        <small>4.5.1　服务申请</small>
        <span>
          一般由运营商标识（OperatorID）、参数内容（Data）、时间戳（TimeStamp）、自增序列（Seq）和数字签名（Sig）组成。<br /><br />
          表1　消息主体内容表</span
        >
        <img class="pc_img" src="@/assets/menthu/4/1.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/4/1.png" alt="" />

        <small>4.5.2　参数返回</small>
        <span
          > 
          数据传输接口的返回参数一般由返回值（Ret）、返回信息（Msg）、参数内容（Data）和数字签名（Sig）组成。<br /><br />1)Ret:必填字段，返回编码参考下表。<br /><br />2)Msg:必填字段，有错误表示具体错误信息，无错误返回成功信息。<br /><br />3)Data:参数内容，具体返回参数见《电动汽车充换电服务信息交换
          第2部分：公共信息交换规范》、《电动汽车充换电服务信息交换
          第3部分：业务信息交换规范》，采用utf-8编码，JSON格式。<br /><br />表2　返回参数编码表</span
        >
        <img class="pc_img" src="@/assets/menthu/4/2.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/4/2.png" alt="" />
        <small>4.6　重发机制</small>
        <span
          >数据传输过程中应设置重发机制，重发次数应大于3次，重发周期宜为1分钟。</span
        >
        <small>4.7　批量数据传输</small>
        <span
          >数据传输接口中的Data字段可为数组型的JSON格式，数据发送方可通过该字段实现批量数据的传输。</span
        >
        <p>5.平台认证要求</p>
        <small>5.1　基本要求</small>
        <span
          >电动汽车充换电服务信息交换应根据国家信息安全等级保护相关要求。<br /><br />电动汽车充换电服务信息交换应具备平台认证服务提供平台之间的鉴权认证功能。平台之间在信息交换前，需完成平台认证，获得平台交换能力。<br /><br />运营商须提供严格的系统安全保密机制，保障信息交换接口安全、稳定、可靠地运行，包括信息的存取控制、应用系统操作的安全等。基本要求：<br /><br />1)采用身份认证、访问控制、数据加密、数字签名等安全措施；<br /><br />2)采用安全可靠并且普遍使用的加密算法；<br /><br />3)密钥的存贮和交易信息的加密／解密需要在安全的环境中；<br /><br />4)遵循数据安全保密的国家和行业标准；<br /><br />5)定期更换密钥；<br /><br />6)具备对报文做来源正确性鉴别的机制（HMAC）。</span
        >

        <small> 5.2　平台认证方式及规则</small>
        <small>5.2.1　平台认证模式</small>

        <span
          >平台认证应支持分布式认证模式或中心交换认证模式，具体结构参见图1。<br /><br />分布式认证模式由运营商之间进行鉴权认证，具体认证方式可由运营商协商确定。中心交换认证模式由统一的认证服务方提供鉴权认证服务，具体认证方式由各运营商和认证服务方共同确定。</span
        >
        <img class="pc_img" src="@/assets/menthu/4/3.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/4/3.png" alt="" />
        <small>5.2.2　平台认证方法</small>
        <span
          >平台认证宜采取身份认证和访问控制相结合的方式进行，相关流程参见图2。<br /><br />身份认证可采取用户名/口令认证、密钥认证或数字证书认证等方式进行；访问控制可采取IP访问控制、时间访问控制等多种手段结合。<br /><br />用户身份认证成功后授予Token，每次向服务端请求资源的时候需要带着服务端签发的Token，服务端验证Token成功后，才返回请求的数据。Token的有效期由服务方确定，最长不应超过7天，Token丢失或失效后需要再次发起认证服务。认证接口规范参见附录A。</span
        >
        <img class="pc_img" src="@/assets/menthu/4/4.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/4/4.png" alt="" />
        <p>6.密钥的管理和使用</p>
        <small>6.1　基本要求</small>
        <span
          >运营商应满足数据安全传输控制方面的要求。<br /><br />
          运营商应提供严格的系统安全保密机制，保障信息交换接口安全、稳定、可靠地运行，包括信息的存取控制、应用系统操作的安全等。<br /><br />密码算法用于密钥的产生、分发、HMAC以及加密等安全功能，相关的算法模块在其生命周期内不能被修改、导出至安全环境外部。<br /><br />指定功能的密钥仅能做指定功能使用，不能被其他任何功能使用。</span
        >
        <small>6.2　密钥的分类</small>
        <span>
          每个运营商交互前需要分配运营商标识、运营商密钥、消息密钥、消息密钥初始化向量和签名密钥。具体要求如下：<br /><br />1)运营商标识（OperatorID）:
          固定9位，运营商的组织机构代码，作为运营商的唯一标示。<br /><br />2)运营商密钥（OperatorSecret）:可采用32H、48H和64H，由
          0-F字符组成，为申请认证使用。<br /><br />3)消息密钥（DataSecret）:用于对所有接口中Data信息进行加密。<br /><br />4)消息密钥初始化向量（DataSecretIV）：固定16位，用户AES加密过程的混合加密。<br /><br />5)签名密钥（SigSecret）:
          可采用32H、48H和64H，由 0-F字符组成，为签名的加密密钥。</span
        >
        <small> 6.3　密钥的管理</small>
        <small>6.3.1　密钥的产生</small>
        <span
          >数据密钥应具备随机产生特性，密钥产生后要检查密钥的有效性，弱密钥和半弱密钥需被剔除。<br /><br />运营商加入信息交换时，必须申请独立的密钥文件，密钥可由运营商协商产生。</span
        >
        <small>6.3.2　密钥的分发</small>
        <span
          >密钥的分发应该由安全方式进行，可通过线下分发、联机报文或数字信封的方式加密传输。</span
        >
        <small> 6.3.3　密钥的存储</small>
        <span
          >密钥宜保存在硬件加密机内。如果出现在硬件加密机外，则必须密文方式出现。<br /><br />密钥注入、密钥管理和密钥档案的保管应由专人负责。使用密钥和销毁密钥要在监督下进行并应有使用、销毁记录。</span
        >
        <small>6.3.4　密钥的销毁</small>
        <span
          >当新密钥产生后，生命期结束的旧密钥必须从数据库和内存中清除，防止被替换使用；同时所有可能重新构造此密钥的信息也必须清除。新密钥成功启用和旧密钥自动销毁的记录将被更新。</span
        >
        <small>6.4　密钥的使用</small>
        <small>6.4.1　数据的加解密处理</small>
        <span
          >消息发送方需要对Data字段中涉及交易及隐私等数据利用消息密钥（DataSecret）进行加密。<br /><br />消息接收方收到消息之后，根据消息密钥（DataSecret）对消息体中的Data数据进行解密，校验参数合法性等后续业务处理。具体加解密方法和示例见附录B。</span
        >
        <small>6.4.2　参数签名规范</small>
        <span
          >参数签名采用HMAC-MD5算法，采用MD5作为散列函数，通过签名密钥（SigSecret）对整个消息主体进行加密，然后采用Md5信息摘要的方式形成新的密文，参数签名要求大写。<br /><br />参数签名顺序按照消息体顺序拼接后执行，拼接顺序为运营商标识（OperatorID）、参数内容（Data）、时间戳（TimeStamp）、自增序列（Seq）。具体参数签名方法和示例见附录C。</span
        >

        <p>附　录　A</p>
        <span>（规范性附录）<br /><br />分布式认证的认证接口规范</span>
        <small>A.1　概述</small>
        <span
          >此接口用于平台之间认证Token的申请，Token作为全局唯一凭证，调用各接口时均需要使用。</span
        >
        <small> A.2　接口定义</small>
        <span>
          接口名称：query_token<br /><br />接口使用方法：由服务端实现此接口，需求端调用。</span
        >
        <small>A.3　输入参数</small>
        <img class="pc_img" style="margin-top: 0px" src="@/assets/menthu/4/5.png" alt="" />
        <img class="mo_img" style="margin-top: 0px" src="@/assets/mohu/4/5.png" alt="" />
        <small>A.4　返回值</small>
        <img class="pc_img" style="margin-top: 0px" src="@/assets/menthu/4/6.png" alt="" />
        <img class="mo_img" style="margin-top: 0px" src="@/assets/mohu/4/6.png" alt="" />
        <small> A.5　示例</small>
        <span>无</span>
        <p>附　录　B</p>
        <span>（资料性附录）<br /><br />数据加密方式</span>
        <small>B.1　数据加密方法</small>
        <span
          >数据传输的加密使用对称加密算法AES
          128位加密，加密模式采用CBC，填充模式采用PKCS5Padding方式。</span
        >
        <small> B.2　数据加密示例</small>
        <span
          >示例密钥：1234567890abcdef<br /><br />示例初始向量：1234567890abcdef<br /><br />示例明文信息：<br /><br
        /></span>
        <img class="pc_img" style="margin-top: 0px" src="@/assets/menthu/5/1.png" alt="" />
        <img class="mo_img" style="margin-top: 0px" src="@/assets/mohu/5/1.png" alt="" />

        <img class="pc_img" style="margin-top: 0px" src="@/assets/menthu/5/2.png" alt="" />
        <img class="mo_img" style="margin-top: 0px" src="@/assets/mohu/5/2.png" alt="" />
        <p>附　录　C</p>
        <span>（资料性附录）<br /><br />HMAC-MD5参数签名方式</span>
        <small>C.1　HMAC-MD5参数签名算法</small>
        <span>
          HMAC（K，M）=H（K⊕opad∣H（K⊕ipad∣M））<br /><br />其中:K是密钥（OperatorSecret），长度可为64字节，若小于该长度，在密钥后面用“0”补齐。<br /><br />M是消息内容；<br /><br />H是散列函数；<br /><br />opad和Ipad分别是由若干个0x5c和0x36组成的字符串；<br /><br />⊕表示异或运算；<br /><br />∣表示连接操作。</span
        >
        <small> C.2　HMAC-MD5参数签名流程</small>
        <span
          >1)在签名密钥（SigSecret）后面添加0来创建一个长为64字节的字符串(str)；<br /><br />2)将上一步生成的字符串(str)与ipad(0x36)做异或运算，形成结果字符串(istr)；<br /><br />3)将消息内容data附加到第二步的结果字符串(istr)的末尾；<br /><br />4)做md5运算于第三步生成的数据流(istr)；<br /><br />5)将第一步生成的字符串(str)与opad(0x5c)做异或运算，形成结果字符串(ostr)；<br /><br />6)再将第四步的结果(istr)附加到第五步的结果字符串(ostr)的末尾；<br /><br />7)做md5运算于第六步生成的数据流(ostr)，输出最终结果(out)。</span
        >
        <small> C.3　参数签名示例</small>
        <span
          >示例签名密钥：1234567890abcdef<br /><br />示例运营商标识（OperatorID）：123456789</span
        >
        <img class="pc_img" style="margin-top: 0px" src="@/assets/menthu/5/3.png" alt="" />
        <img class="mo_img" style="margin-top: 0px" src="@/assets/mohu/5/1.png" alt="" />
        <br />
        <span
          >示例时间戳（TimeStamp）:20160729142400<br /><br />示例自增序列（Seq）：0001<br /><br />示例签名（Sig）：745166E8C43C84D37FFEC0F529C4136F</span
        >
      </div>
    </div>
  </div>
</template>


<script>
import Menthu from "@/components/menthu";
export default {
  components: {
    Menthu,
  },
};
</script>

<style scoped>
.home_con {
  display: flex;
  text-align: left;
}
small {
  font-family: Helvetica;
  margin-top: 24px;
}
.mentCon{
   margin-top:10px;
}
.mentCon .text_hh {
  margin-top: 12px;
  display: flex;
  font-size: 12px;
  font-family: Helvetica;
  color: #191c27;
  line-height: 18px;
}
</style>


// WEBPACK FOOTER //
// src/page/document/documentl.vue